export class CreateSuscripcioneDto {}
